import React from "react";

type InputHelperTextType = {
  /** Name to programatically link it to an input. Passed from the input as inputname + Desc. E.g. `firstNameDesc` */
  name: string;
  /** Error text to show when there is an error */
  errorText?: string;
  /** Optional helper text for an input. Pass in helper text, it will turn red if the field is in error. */
  helperText?: string;
};

export const InputHelperText: React.FC<InputHelperTextType> = ({
  name,
  errorText,
  helperText,
}) => {
  return (
    <div className="input-wrapper__helper" id={name}>
      {helperText && <p className="input-wrapper__helper-text">{helperText}</p>}
      {errorText && <p className="input-wrapper__error-text">{errorText}</p>}
    </div>
  );
};
